import { DealerWiseTopBuyRptServices } from '../services';
import { DealerWiseTopBuyRptConstants } from '../constants';
import { alertActions } from '.';

export const DealerWiseTopBuyRptAction = {
    getAll,
    loadingData,
    exportData,
    fetchDealers // New action added
};



function getAll(obj) {
    return dispatch => {
        dispatch(request());

        DealerWiseTopBuyRptServices .GetProductDealerSummary(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))


            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) {
                    delete v.TotalRows; delete v.CreatedBy;
                    delete v.DocURL; delete v.MappingId; delete v.ProductID
                });
            }
            dispatch(successExport(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type:  DealerWiseTopBuyRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: DealerWiseTopBuyRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type:  DealerWiseTopBuyRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: DealerWiseTopBuyRptConstants.GETALL_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        DealerWiseTopBuyRptServices .GetDealerInvoicing(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) {
                    delete v.TotalRows; delete v.CreatedBy;
                    delete v.DocURL; delete v.MappingId; delete v.ProductID
                });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type:  DealerWiseTopBuyRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type:  DealerWiseTopBuyRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type:  DealerWiseTopBuyRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: DealerWiseTopBuyRptConstants.LOADING_REQUEST, isbool
    }
}

// New function to fetch dealer list
function fetchDealers() {
    return dispatch => {
        dispatch(request());
        DealerWiseTopBuyRptServices .GetDealers().then(
            response => {
                dispatch(success(response.ResponseData));
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type:  DealerWiseTopBuyRptConstants.GETDEALERS_REQUEST }; }
    function success(datas) { return { type:  DealerWiseTopBuyRptConstants.GETDEALERS_SUCCESS, datas }; }
    function failure(error) { return { type:  DealerWiseTopBuyRptConstants.GETDEALERS_FAILURE, error }; }
}